import { notification } from 'antd';
import { useAddUrlAnalysisProcessMutation } from '../service';

export default function useAddUrlAnalysisProcessWithNotification() {
    const [addUrlAnalysisProcessTrigger, { isLoading: isAddingUrlAnalysisProcess }] = useAddUrlAnalysisProcessMutation();

    const addUrlAnalysisProcess = async (websiteGuid: string, urlGuid: string) => {
        try {
            await addUrlAnalysisProcessTrigger({ url_guid: urlGuid, w_guid: websiteGuid }).unwrap();
            notification.success({ message: "We've started to analyze your webpage", description: "Please check for the results later" });
        } catch (error) {
            notification.error({ message: "Something went wrong!", description: "Please try again or contact support" });
        }
    };

    return {
        addUrlAnalysisProcess,
        isAddingUrlAnalysisProcess,
    };
}
